module.exports = __webpack_public_path__ + "img/chromecast_video_art.c86b80d.png";